import { FontWeight, css } from '$utils/theme'
import styled from 'styled-components'
import { rem } from 'polished'
import { Block } from '../Layout/Block'

interface Props {
  isOpened?: boolean
  width?: number
}

export const StyledWrapper = styled.div`
  position: relative;
`

export const StyledInputIcon = styled.span`
  border-color: ${p => p.theme.colors.darkGrey};
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  content: ' ';
  display: inline-block;
  margin-top: -ceil(2.5);
  position: absolute;
  right: 21px;
  top: 18px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
`

export const StyledInput = styled.input.attrs({})<Props>`
  width: 100%;
  left: 0;
  padding: 0.75rem;
  padding-left: 1rem;
  border: solid 1px ${p => p.theme.colors.lightGrey};
  border-radius: ${p => rem(p.theme.sizes.small)};
  color: ${p => p.theme.colors.darkGrey};
  ${p => p.theme.font.base(FontWeight.regular)};

  &::placeholder {
    color: #aeaeae;
  }

  &:hover {
    cursor: pointer;
  }

  ${p =>
    p.isOpened &&
    css`
      outline: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-color: ${p.theme.colors.darkGrey};
    `} ${p =>
    !p.isOpened &&
    css`
      outline: none;
      border-bottom-left-radius: ${rem(p.theme.sizes.small)};
      border-bottom-right-radius: ${rem(p.theme.sizes.small)};
    `};
`
export const StyledWrapperCalendar = styled.div`
  z-index: 3;
  position: absolute;
`

export const StyledBlock = styled(Block).attrs({})<Props>`
  width: ${p => (p.width ? p.width : 100)}% !important;
`



// WEBPACK FOOTER //
// ./src/views/components/Datepicker/Datepicker.style.ts